module.exports = __webpack_public_path__ + "img/lessonpre_narrow_packup_act.d138c8e0.svg";